/**
 * HomeENAlmadarHomePageView
 *
 * Page component for HomeENAlmadarHomePageView
 * Path: /
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { HomeENAlmadarHomePageView as __HomeENAlmadarHomePageView } from '@/components/traits/HomeENAlmadarHomePageView';
import { HomeENHomeAnalyticsView as __HomeENHomeAnalyticsView } from '@/components/traits/HomeENHomeAnalyticsView';
import { HomeENDemoTicketDeskView as __HomeENDemoTicketDeskView } from '@/components/traits/HomeENDemoTicketDeskView';
import { HomeENDemoStockPageDeskView as __HomeENDemoStockPageDeskView } from '@/components/traits/HomeENDemoStockPageDeskView';
import { HomeENDemoPeopleDeskView as __HomeENDemoPeopleDeskView } from '@/components/traits/HomeENDemoPeopleDeskView';
import { HomeENDemoInvoicePageDeskView as __HomeENDemoInvoicePageDeskView } from '@/components/traits/HomeENDemoInvoicePageDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface HomeENAlmadarHomePageViewProps {
  // Add any page-level props here
}

export function HomeENAlmadarHomePageView(_props: HomeENAlmadarHomePageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-home:meta.title"],"description":["i18n/t","std-almadar-home:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__HomeENAlmadarHomePageView config={{ initPayload: __navState }} />
          <__HomeENHomeAnalyticsView config={{ initPayload: __navState }} />
          <__HomeENDemoTicketDeskView config={{ initPayload: __navState }} />
          <__HomeENDemoStockPageDeskView config={{ initPayload: __navState }} />
          <__HomeENDemoPeopleDeskView config={{ initPayload: __navState }} />
          <__HomeENDemoInvoicePageDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default HomeENAlmadarHomePageView;
